"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var past_classes_and_courses_controller_1 = __importDefault(require("./past-classes-and-courses.controller"));
var past_classes_and_courses_html_1 = __importDefault(require("./past-classes-and-courses.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.coursehistory", {
        url: "/course-history",
        template: past_classes_and_courses_html_1.default,
        controller: past_classes_and_courses_controller_1.default,
        controllerAs: "vm",
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.parent,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.coureshistory", [])
    .config(config)
    .controller("StudentCourseHistory", past_classes_and_courses_controller_1.default);
